export default "__VITE_PUBLIC_ASSET__04c5926f__"